// removed by extract-text-webpack-plugin
module.exports = {"create-event-header":"_28fgd5BIea23LlWOcQ2Gas"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/Events/containers/EventsContainer.scss
// module id = 1179
// module chunks = 1